'use strict'

// A sample component

const Video = {
    init: function () {
        if (document.querySelector('.block-video__container')) {
            this.playVideo();

        }
    },
    playVideo: function () {
        const playBtn = document.querySelector('.video-poster');
        const videoContainer = document.querySelector('.video');
        playBtn.addEventListener('click', () => {
            videoContainer.querySelector('iframe').src += "&autoplay=1";
            // video.play();
            playBtn.style.display = "none";
        });
    },


}


export default Video;
